import { capfirst } from 'journalize';
import cx from 'classnames';
import { h } from 'preact';

function PartyPill({ excludeInitial, party, style }) {
  const partyPrefix = party.slice(0, 3).toLowerCase();
  const partyInitial = party[0].toUpperCase();

  const classes = cx('circle-pill', `pill--${partyPrefix}`);

  return (
    <span class={classes} style={style} title={capfirst(party)}>
      {!excludeInitial && partyInitial}
    </span>
  );
}

PartyPill.defaultProps = {
  excludeInitial: false,
};

export default PartyPill;
